export enum ReportSubjectSubtypeEnum {
  GOODS = 'GOODS',
  SERVICES = 'SERVICES',
  DIGITAL_PRODUCTS = 'DIGITAL_PRODUCTS',
  CORPORATE = 'CORPORATE',
  PRIVATE = 'PRIVATE',
  ALL = 'ALL',
}
